import * as React from 'react';
export const stellarSvg = React.forwardRef(function stellarSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M28 10.932v2.064l-.873.444a1.845 1.845 0 0 0-1.002 1.783 10.14 10.14 0 0 1-5.515 9.811 10.165 10.165 0 0 1-10.575-.829l1.793-.912.101-.054a8.322 8.322 0 0 0 8.265-.077 8.3 8.3 0 0 0 4.043-8.251L10.268 22.02l-2.89 1.47L4 25.21v-2.07l3.402-1.732 1.653-.842L28 10.932ZM11.388 6.967a10.165 10.165 0 0 1 10.577.827l-.247.126-1.654.841a8.322 8.322 0 0 0-8.257.086 8.3 8.3 0 0 0-4.039 8.236l13.955-7.099 2.89-1.47L28 6.788v2.07l-3.417 1.74-1.653.84-14.71 7.488-.82.417-.831.424L4 21.072V19l.872-.444a1.844 1.844 0 0 0 1.003-1.783 10.14 10.14 0 0 1 5.512-9.807Z',
    }),
  );
});
stellarSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var stellar = {
  category: 'brand',
  colorable: false,
  name: 'stellar',
  svg: stellarSvg,
};
